module.exports = __webpack_public_path__ + "img/letters-preview.9851e51a.svg";